var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete24 = function SvgDelete24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9 6a5.002 5.002 0 0 0-9.8 0H3a1 1 0 0 0 0 2h1.069l.668 9.356A5 5 0 0 0 9.724 22h4.551a5 5 0 0 0 4.988-4.644L19.93 8H21a1 1 0 1 0 0-2h-4.1ZM12 4a3.001 3.001 0 0 0-2.83 2h5.66A3.001 3.001 0 0 0 12 4Zm5.926 4H6.074l.658 9.214A3 3 0 0 0 9.724 20h4.551a3 3 0 0 0 2.993-2.786L17.926 8Z",
    fill: "currentColor"
  })));
};
export default SvgDelete24;